import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@src/common';
import navbarStore from '@/store/navbar';
import modelChoiceStore from '@/components/model-choice/store.js';
import localRobot from '@/common/localRobot.js';
import client from '@/store/client';
class Store {
  list = [];
  npt = '';
  wd = '';
  tag = '';
  tagList = [];
  choiceList = [];
  filterList = [];

  constructor() {
    makeAutoObservable(this);
  }

  getPageSize = (scene, simple) => {
    if (simple) return 50;
    const list_wrap = document.getElementById(`model_list_wrap_${scene}`);
    const isSquare = scene == 'square';
    const maxCount = list_wrap.offsetHeight / (isSquare ? 109 : 78);
    if (maxCount < 10) {
      return isSquare ? 20 : 10;
    } else if (maxCount >= 10 && maxCount <= 20) {
      return isSquare ? 40 : 20;
    } else {
      return 50;
    }
  };
  setWd = wd => {
    runInAction(() => {
      this.wd = wd;
    });
  };

  toggleChoice = (item, isChoiced) => {
    runInAction(() => {
      if (isChoiced) {
        this.choiceList = this.choiceList.filter(_item => item.id != _item.id);
      } else {
        this.choiceList.push(item);
      }
    });
  };

  mergeList(raw = []) {
    let ret = []
    if (raw?.length) {
      raw.forEach(item => {
        if (!ret.find(i => i.id == item.id)) {
          ret.push(item)
        }
      })
    }
    return ret
  }

  filteList() {
    this.list = this.list.filter(item => {
      return !this.filterList.find(filterItem => item.id == filterItem.id)
    })
  }

  getTag = () =>
    request.get('/robot/tab', {params: {ai_agent: 1}}).then(res => {
      this.tagList = [{
        key: "",
        order: "0",
        title: "全部"
      }, ...res.data.tags].filter(tag => !(tag.type === 100 && !client.isLLQ))
    })

  /**
   * 获取所有数字人列表
   */
  getList = (first = false, scene = "", _scene = "", simple, searchUrl) => {
    this.getting = true;
    if (first) {
      this.npt = '';
    }
    let url = searchUrl || '/robot/home';
    request
      .get(url, {
        params: {
          size: first ? this.getPageSize(scene, simple) : 10,
          npt: this.npt,
          tag: this.tag,
          wd: this.wd,
          ai_agent: 1,
          scene: _scene || ""
        },
      })
      .then(res => {
        const list = res.data?.list || [];
        let mergeList = res.data?.merge_list || [];
        const npt = res.data?.npt || '';

        runInAction(() => {
          if (first) {
            this.list = list;
          } else {
            this.list = [...this.list, ...list];
          }
          this.filteList()
          if (!this.tag) {
            if (this.wd) {
              const wd = this.wd.toLowerCase();
              mergeList = mergeList.filter(item => (item.title || "").toLowerCase().includes(wd));
            } else {
              mergeList = localRobot.localModels || [];
            }
            this.list = mergeList.concat(this.list)
            this.list = this.mergeList(this.list)
          }
          // 筛选出添加到广场的
          this.list = this.list.filter(model => model.chat_type === 10 || model.state === 1 || model.tag == "ai_agent");
          this.npt = npt;

          const index = this.list.findIndex((item) => item.title && /deepseek.*满血/i.test(item.title));
          if (index !== -1) {
            modelChoiceStore.switchCurId(this.list[index].id);
            this.list.unshift(this.list.splice(index, 1)[0])
          }
        });
        navbarStore.setChatModels(this.list);
      })
      //.catch(Loader.error)
      .finally(() => {
        runInAction(() => {
          this.getting = false;
        });
      });
  };
  
  getListByTag = (tag = "", scene = "", _scene = "") => {
    this.tag = tag;
    this.getList(true, scene, _scene);
  };
}

export default Store;
